import classes from "./StatusTooltip.module.css";

export function FileStatusTooltip() {
  return (
    <dl className={classes.inlineDl}>
      <dt>Unmapped</dt>
      <dd>The file has been uploaded but no mapping has been done yet.</dd>
      <dt>Processing</dt>
      <dd>The file is being processed.</dd>
      <dt>Mapped</dt>
      <dd>The file has been processed, and the products have been imported.</dd>
      <dt>Failed</dt>
      <dd>The file could not be read, see details.</dd>
    </dl>
  );
}

export function ListingStatusTooltip() {
  return (
    <dl className={classes.inlineDl}>
      <dt>Original</dt>
      <dd>
        This listing has not yet been optimised. It is in its original form from
        your upload.
      </dd>
      <dt>Optivised</dt>
      <dd>
        This listing was optimised by Optivise. No manual changes have been
        made.
      </dd>
      <dt>Edited</dt>
      <dd>
        You manually edited this listing after uploading. Optivise was not
        applied.
      </dd>
      <dt>Optivised & Edited</dt>
      <dd>
        This listing was first optimised by Optivise, then manually edited by
        you.
      </dd>
    </dl>
  );
}
